$(document).ready(function () {
  /* The following script filters questions in How it work FAQ section */
  let filterQuestion = function () {
    let valThis = $('#filterQuestions').val().toLowerCase();
    let totalBox = $('.boxquestion').length;
    let counterVisible = 0;

    $('.boxquestion').each(function () {
      var text = $(this).text().toLowerCase();
      if (text.indexOf(valThis) !== -1) {
        $('#notmatches').hide();
        $(this).show();
      } else {
        $(this).hide();
        counterVisible++;
        if (counterVisible == totalBox) {
          $('#notmatches').show();
        }
      }
    });
  };
  $('#clearSearch').click(function () {
    $('#filterQuestions').val('');
    $('#clearSearch').hide();
    filterQuestion();
  });
  $('#filterQuestions').keyup(filterQuestion);
});
